const Setting = () => import(/* webpackChunkName: "setting" */ '@/views/private/setting/Index.vue')
const Member = () => import(/* webpackChunkName: "settingmember" */ '@/components/setting/Member.vue')
const Category = () => import(/* webpackChunkName: "settingcategory" */ '@/components/setting/Category.vue')
const Leaf = () => import(/* webpackChunkName: "settingleaf" */ '@/components/setting/Leaf.vue')
const Config = () => import(/* webpackChunkName: "settingconfig" */ '@/components/setting/Config.vue')

const routes = [
  {
    path: "/setting",
    name: "setting",
    component: Setting,
    meta: {
      title: "Pengaturan"
    },
    children: [
      {
        path: '/setting/member',
        name: 'setting member',
        component: Member,
        meta: {
          title: "Pengaturan Pengguna"
        }
      },
      {
        path: '/setting/category',
        name: 'setting category',
        component: Category,
        meta: {
          title: "Pengaturan Konten Kategori"
        }
      },
      {
        path: '/setting/leaf',
        name: 'setting leaf',
        component: Leaf,
        meta: {
          title: "Pengaturan Halaman (page)"
        }
      },
      {
        path: '/setting/config',
        name: 'setting config',
        component: Config,
        meta: {
          title: "Pengaturan Konfigurasi"
        }
      }
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})